import { render } from "./field_submitter.vue?vue&type=template&id=4b1bca72"
import script from "./field_submitter.vue?vue&type=script&lang=js"
export * from "./field_submitter.vue?vue&type=script&lang=js"

import exportComponent from "/build/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__